import { request } from './helpers/request'

export const submitPasswordReset = (data) =>
  request({
    url: '/users/password/recover',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    data: data,
  }).then((response) => {
    if (response.status === 204) {
      return Promise.resolve(response)
    }

    return Promise.reject(new Error(String(response.status)))
  })
